import { Link } from 'react-router-dom';
import Logo from '../assets/images/Logo.svg';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import AccentureLogo from '../assets/images/Accenture.svg';
import ichecLogo from '../assets/images/ichec.svg';
import noPhoto from '../assets/people/noPhoto.png';

// Accenture
import kcPhoto from '../assets/people/kung-chuan.hsu.jpg';
import photoGiedriusPacevicius from '../assets/people/giedrius_pacevicius.jpg';
import photoTomasZubric from '../assets/people/tomas.zubrik.jpg';
import photoHassanNaseri from '../assets/people/hassan.naseri.jpg';
import photoVictoriaPerrone from '../assets/people/victoria.perrone.png';
import photoAlbertoGarcia from '../assets/people/a.b.garcia.garcia.jpg';
import photoJamesTricker from '../assets/people/james.tricker.jpg'
import photoMedbCorcoran from '../assets/people/medb.corcoran.jpg'

function PfasCredits() {
  const accPeople = [
    {
      id: 0,
      name: 'Dr. Hassan Naseri',
      job_title: 'Technical Quantum Information Lead',
      image: photoHassanNaseri,
    },
    {
      id: 1,
      name: 'James Tricker',
      job_title: 'Quantum Chemist',
      image: photoJamesTricker,
    },
    {
      id: 2,
      name: 'Kung-Chuan Hsu',
      job_title: 'Quantum Information Scientist',
      image: kcPhoto,
    },
    {
      id: 3,
      name: 'García García, Alberto',
      job_title: 'Quantum Chemist',
      image: photoAlbertoGarcia,
    },
    {
      id: 4,
      name: 'Tomáš Zúbrik',
      job_title: 'UX/UI Designer',
      image: photoTomasZubric,
    },
    {
      id: 5,
      name: 'Giedrius Pacevičius',
      job_title: 'Front-end Developer',
      image: photoGiedriusPacevicius,
    },
    {
      id: 6,
      name: 'Victoria Perrone',
      job_title: 'Back-end Developer',
      image: photoVictoriaPerrone,
    },
    {
      id: 7,
      name: 'Medb Corcoran',
      job_title: 'Accenture Program Lead',
      image: photoMedbCorcoran,
    },
  ];

  const ichecPeople = [
    {
      id: 0,
      name: 'Venkatesh Kannan',
      job_title: '',
      image: noPhoto,
    },
    {
      id: 1,
      name: 'Goar Sanchez',
      job_title: '',
      image: noPhoto,
    },
    {
      id: 2,
      name: 'James Nelson',
      job_title: '',
      image: noPhoto,
    },
    {
      id: 3,
      name: 'Emil Dimitrov',
      job_title: '',
      image: noPhoto,
    },
    {
      id: 4,
      name: 'Sean Courtney',
      job_title: '',
      image: noPhoto,
    },
    {
      id: 5,
      name: 'Bruno Chagas',
      job_title: '',
      image: noPhoto,
    },
    {
      id: 6,
      name: 'Conor Dunne',
      job_title: '',
      image: noPhoto,
    },
  ];

  return (
    <>
      <div className='navigation'>
        <div className='logo'>
          <img src={Logo} alt='Quantum logo' />
        </div>
        <div className='nav'>
          <Link to='/conclusion' className='pfas-btn-white-back'>
            <div className='nav-text-back'>Previous</div>
          </Link>
          <Link to='/'>
            <div className='nav-home'></div>
          </Link>

          {/* <div className='nav-page-nr'>3/9</div> */}

          {/* <Link to='/pfasimpacts' className='pfas-btn-blue-next'>
              <div className='nav-text-next'>Next</div>
            </Link> */}
        </div>
      </div>
      <div className='pfas-credits pfas-container'>
        <Row>
          <div className='credits'>
            <Col xs={12} lg={6}>
              <div className='text-left'>
                <div className='slogan'>Credits</div>
                <div className='headline'>Our team</div>
                <div className='text'>
                  In this project, we collaborated with a research team from the
                  Quantum Computer Science Centre of the Faculty of Computing of
                  the University of Latvia.
                </div>
                <div className='company-logo'>
                  <img src={AccentureLogo} alt='Accenture logo' />
                </div>
                <div className='coleagues'>
                  {accPeople.map((acc) => {
                    return (
                      <>
                        <div className='single-coleague' key={acc.id}>
                          <div className='image'>
                            <img src={acc.image} alt={acc.name} />
                          </div>
                          <div className='name'>{acc.name}</div>
                          <div className='job-title'>{acc.job_title}</div>
                        </div>
                      </>
                    );
                  })}
                </div>
              </div>
            </Col>
            <Col xs={12} lg={6}>
              <div className='image-right'>
                {/* <div className='cycle-image'> */}
                <div className='company-logo'>
                  <img src={ichecLogo} alt='Ichec logo' />
                </div>
                <div className='coleagues'>
                  {ichecPeople.map((person) => {
                    return (
                      <>
                        <div className='single-coleague' key={person.id}>
                          <div className='image'>
                            <img src={person.image} alt={person.name} />
                          </div>
                          <div className='name'>{person.name}</div>
                          <div className='job-title'>{person.job_title}</div>
                        </div>
                      </>
                    );
                  })}
                </div>
                {/* </div> */}
              </div>
            </Col>
          </div>
        </Row>
      </div>
    </>
  );
}

export default PfasCredits;
